export const CREATURE_UPDATE = 'CREATURE_UPDATE';
export const ENTER_SHOP = 'ENTER_SHOP';
export const PLAYER_ACTION = 'PLAYER_ACTION';
export const PLAYER_UPDATE_HAND = 'PLAYER_UPDATE_HAND';
export const PLAYER_UPDATE_STATS = 'PLAYER_UPDATE_STATS';
export const TICK_SEGMENT = 'TICK_SEGMENT';
export const TICK = 'TICK';
